import AdditionalInformation from './AdditionalInformation'
import QRCodeImage from './QRCodeImage'

export default class Transaction {
  constructor (data) {
    data = data || {}

    this.title = data?.title
    this.description = data?.description
    this.rawAmount = data?.amount || 0
    this.amount = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(this.rawAmount / 100)
    this.copyCode = data?.paymentData?.code
    this.qrCodeImage = new QRCodeImage(data?.paymentData)
    this.additionalInformation = data?.paymentData?.additionalInformation.map((additionalInformation) => {
      return new AdditionalInformation(additionalInformation)
    })
    this.is_expired = data?.is_expired
    this.is_paid = data?.is_paid
  }
}
